interface SVGIcon {
  name: string;
  url: string;
}

export const SVG_ICONS: SVGIcon[] = [
  {
    name: 'clear_search',
    url: './assets/icons/material-icons/clear-search.svg'
  },
  {
    name: 'chat_notification',
    url: './assets/icons/material-icons/chat-notification.svg'
  },
  {
    name: 'remove_favorite',
    url: './assets/icons/material-icons/remove-favorite.svg'
  },
  {
    name: 'share_off',
    url: './assets/icons/material-icons/share-off.svg'
  },
  {
    name: 'synonym_dark',
    url: './assets/icons/material-icons/synonym-dark.svg'
  },
  {
    name: 'calculator',
    url: './assets/icons/material-icons/calculator.svg'
  },
  {
    name: 'draft',
    url: './assets/icons/material-icons/draft.svg'
  },
  {
    name: 'bullhorn',
    url: './assets/icons/material-icons/bullhorn.svg'
  },
  {
    name: 'nmfta_article',
    url: './assets/icons/material-icons/nmfta_article.svg'
  },
  {
    name: 'note_stack',
    url: './assets/icons/material-icons/note_stack.svg'
  },
  {
    name: 'book_2',
    url: './assets/icons/material-icons/book_2.svg'
  }
];
